module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rBTVGr/tc-custom/9798889103974.jpg?1726273999587",
      "alt": "This image is the cover for the book Detective Ray Shields and the Mountain of Trial"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Detective Ray Shields and the Mountain of Trial\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ray Shields isn’t your average private eye. He’s a little more like your traditional gumshoe than most, and in his line of work, being dedicated to the job is a good thing. Laura is his secretary and, as far as Ray is concerned, she is the best one he’s has ever had. She’s never late to work, she keeps his affairs in order, and most importantly, she always has the coffee brewing. Then there’s Eddie, Ray’s partner. He’s a dedicated alcoholic with a troubled past, but he doesn’t let that affect his work. Together, the trio make up the Ray Shields Detective Agency, and the only thing separating the R.S.D.A. from the competition is a rusty chain-link fence. ")]), _c('p', [_vm._v("But everything is about to change…")]), _c('p', [_vm._v("One day, after receiving a mysterious envelope in the mail, Ray, Laura, and Eddie find themselves thrust into the heart of an ancient prophecy that places them all in danger and unravels a secret about Laura that’s long been hidden.")]), _c('p', [_vm._v("Together, the R.S.D.A., with the help of a few made friends along the way, will face a myriad of mythical monsters, hunt for a magical relic powerful enough to stop a maddened cultist, and traverse the arid Atacama Desert to fight an ancient evil. Saving the world is all in a day’s work for the Ray Shields Detective Agency.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cyle Tramel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black"
    }
  }, [_vm._v("Cyle Tramel is a seasoned traveler with a passion for cultural exploration and storytelling. He believes that everyone has a story to tell and that every story, no matter how unbelievable, deserves to be told. This is his first book.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0